/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useMouse } from "rooks";
import {
    GridContextProvider,
    GridDropZone,
    GridItem,
    swap,
} from "react-grid-dnd";
import styled, { css } from 'styled-components';
import Grid from '@material-ui/core/Grid';
import debounce from 'lodash.debounce';
import update from 'immutability-helper';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

import map from '../../assets/images/map.png';
import background from '../../assets/images/background.png';
// import { data } from '../../components/SideBar/SideBar';
import { Card } from '../../components/index';
import {
    DiamondSm,
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    GrayCheckMark,
    GameBoardBackground,
    Diamond,
    GoBack3Steps,
    X,
} from '../../Constants/assets';
import { ReactComponent as BackArrow } from '../../assets/images/BackArrow.svg';
import GameBoard from '../../assets/images/GameBoard.png';
import Modal from '../../components/Modal/Modal';

import { Tasks as TasksData } from '../../data/Tasks';
import fetchConfig from '../../Constants/fetch';
import Security from '../../Constants/Security';

import { GeneralPMTasks } from '../../data/GeneralPMTasks';
import TasksArray from './GeneralPMTasks';
import ExpendedMap from './ExpendedMap';


const Container = styled.div`
    /* width: 80%; */
    width: calc(100% - 320px);
    position: relative;
    top: 54px;
    margin: 0 auto;
    justify-content: center;

    @media only screen and (max-width: 1661px) {
        && {
            width: 984px;
        }
    }

    @media only screen and (max-width: 1252px) {
        &&& {
            width: 645px;
        }
    }

    @media only screen and (min-width: 1661px) {
        && {
            width: 1320px;
        }
    }
`;

const styleReset = {
    margin: 0,
    justifyContent: 'flex-start',
};
const styleResetInner = {
    margin: 0,
    position: 'relative',
    justifyContent: 'flex-start',
    transition: 'all 0.5s ease',
};

const MainContent = styled.div`
    width: 62%;
    ${'' /* border: 2px solid black; */}
`;

const Image = styled.img.attrs(props => ({
    src: props.imageData || GameBoard,
}))`
    /* width: 20%; */
    height: 100%;
`;

const ImageWrapper = styled.div`
    width: 220px;
    background: url(${GameBoardBackground});
    background-position: center;
    background-size: 219px 129px;
    background-repeat: no-repeat;
    height: 130px;
    border: 1px solid #ebeced;
    cursor: pointer;
`;
// const ModalContainer = styled.div`
//     display:flex;
// `;
const ModalContainer = styled.div`
    width: 100%;
    height: 100vh;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const ContentGameWrapper = styled.div`
    height: 146px;
    width: 490px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border: 1px solid #ebeced;
    padding-right: 8px;
    @media only screen and (max-width: 1661px) and (min-width: 1252px) {
        width: 100%;
    }
`;
const ContentGameContainer = styled.div`
    @media only screen and (max-width: 1661px) and (min-width: 1252px) {
        width: 45%;
    }
    @media only screen and (max-width: 1252px) {
        width: 100%;
        padding: 10px;
        text-align: -webkit-center;
    }
`;
const BudgetContainer = styled.div`
    width: 50%;
`;
const ValueContainer = styled.div``;
const ResourcesContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    ${'' /* border: 2px solid red; */}
`;
const InformationWrapper = styled.div`
    width: 53%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${'' /* border: solid 2px green; */}
`;
const InformationWrapperFirstLine = styled.div`
    width: 90%;
    height: 100%;
    ${'' /* border: solid 2px green; */}
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;
const Budget = styled.p`
    font-size: 14px;
    line-height: 16px;
`;
const AmountOfBudget = styled.p`
    font-size: 24px;
    font-weight: bold;
`;
const Value = styled.p`
    font-size: 14px;
    line-height: 16px;
`;
const Resources = styled.div`
    font-size: 14px;
    line-height: 16px;
    ${'' /* border: 2px solid blue; */}
    width: 100%;
    text-align: center;
`;
const ValueAmount = styled.p`
    font-size: 24px;
    font-weight: bold;
    width: 100%;
`;

const InformationWrapperSecondLine = styled.div`
    height: 100%;
    ${'' /* border: 2px solid black; */}
    display: flex;
    width: 90%;
    height: 100%;
`;

const PageInfo = styled(Grid)`
    margin: 24px auto;
    // height: 176px;
    /* width: calc(100% - 320px); */
    display: flex;
    ${'' /* border: 2px solid green; */}
    width: 110%;
    @media only screen and (min-width: 1661px) and (min-width: 1252px) {
        justify-content: space-between;
    }
    @media only screen and (max-width: 1252px) {
        ${MainContent} {
            width: 100%;
        }
        height: 525px;
    }
    @media only screen and (max-width: 1661px) and (min-width: 1252px) {
        // ${ContentGameWrapper} {
        //     display: none;
        // }
        ${MainContent} {
            width: 55%;
        }
        height: 225px;
    }
    @media only screen and (max-width: 1252px) {
        height: 374px;
    }

`;

const NavigationWrapper = styled.div`
    height: 24px;
    width: max-content;
    display: flex;
    align-items: center;
    ${'' /* border: 2px solid red; */}
`;

const InfoContentWrapper = styled.div`
    @media only screen and (min-width: 1661px) and (min-width: 1252px){
        justify-content: space-between;
    }
    display: flex;
    ${'' /* border: 2px solid green; */}

    h2 {
        margin-top: 14px;
        line-height: 34px;
        /* font-weight: 700; */
    }

    p {
        color: ${props => props.theme.colors.gray};
    }
`;

const StartButton = styled.button`
    @media only screen and (max-width: 1661px) and (min-width: 1252px)  {
        width: 160px;
    }
    width: 216px;
    height: 50px;
    padding: 0 10px;
    border: none;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${props => (props.disabled ? '0.6' : '1')};

    /* main green */

    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    color: ${props => props.theme.colors.white};
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */
    text-align: center;
`;
const PageGrid = styled(Grid)`
    ${'' /* background-color: #e5e5e5; */}
    transition: all 0.5s ease;
`;

const SwitchContainer = styled.div`
    display: flex;
    border: 1.4px solid ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    overflow: hidden;
    width: 350px;
    margin-top: 2%;
    @media only screen and (max-width: 1661px) and (min-width: 1252px) {
        width: 85%;
    }
`;

const SwitchLeftOption = styled.div`
    padding: 5px 10px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    flex: 1;
    white-space: normal; 
    word-wrap: break-word;
    place-content: center;
    ${props =>
        props.stage == 0
            ? css`
                  background: ${componentProps => componentProps.theme.colors.darkGreen};
                  color: ${componentProps => componentProps.theme.colors.white};
              `
            : css`
                  background: ${componentProps => componentProps.theme.colors.white};
                  color: ${componentProps => componentProps.theme.colors.darkGreen};
                  cursor: pointer;
              `};
    ${props =>
        props.isDisabledPMTasks
            ? css`
                cursor:context-menu;
            `
            : css`
                cursor: pointer;
            `};

`;
const SwitchRightOption = styled.div`
    padding: 5px 10px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    flex: 1;
    white-space: normal; 
    word-wrap: break-word;
    place-content: center;
    color: ${props => props.theme.colors.darkGreen};
    ${props =>
        props.stage == 0
            ? css`
                  background: ${componentProps => componentProps.theme.colors.white};
                  color: ${componentProps => componentProps.theme.colors.darkGreen};
                  cursor: ${componentProps =>
                    componentProps.log.length > 1 || componentProps.playerCurrentPosition != 0 ? 'pointer' : 'not-allowed'};
              `
            : css`
                  background: ${componentProps => componentProps.theme.colors.darkGreen};
                  color: ${componentProps => componentProps.theme.colors.white};
              `};
`;
const LargeMapContainer = styled.div`
    height: 830px;    
    background: ${componentProps => componentProps.theme.colors.white};
    border: 1.4px solid ${props => props.theme.colors.darkGreen};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    z-index: 100;
    position: absolute;
    display: grid;
    align-items: end;
`;
const LargeMapBackground = styled.div`
    background-image: url(${background});
    background-size: 170% 100%;
    background-repeat: no-repeat;    
    // width: 100%;
    width: 800px;
    height: 800px;
    overflow-y:auto;
    overflow-x: hidden;
    position: relative;
`;
const TileContainer = styled.img`
    background-image: url(${map});
    background-size: 100% 100%;
    background-repeat: no-repeat;  
    display:block;
    height: 210%;
    width: 100%;
    position: relative;
   scroll-behavior: smooth;

`;
const CustomGridDropZone = styled(GridDropZone)`
    flex: 1;
    height: 1000px;
    border: 1px dashed rgba(0, 0, 0, 0.0);  
    border-radius: 1rem;
`
const CustomGridContextProvider = styled(GridContextProvider)`
    position: absolute !important;
    top: 0;
    width: 100%;
`;


const Tasks = ({
    socketIO,
    setOpenGeneralPmTasks,
    openGeneralPmTasks,
    taskShow,
    toggleProject,
    markReturnedToBoardFromProject,
    performPlannedTask,
    openStage,
    playerPosition,
    tasks,
    newTurn,
    ProjectInfo,
    initializePlayer,
    playerCurrentPosition,
    generalTask,
    playerId,
    gameId,
    imageData,
    orTasks,
    orTaskChangeHandler,
    showIsPaused,
    isPaused,
    startTurn,
    playerInfo,
    sources,
    toggleStartPlaying,
    ProjectScopeDisable,
    isDisabledPMTasks,
    toggleBeginTurnPopUp,
    StartTurnMessageDisable,
    sendCardsToServer,
    isStartTurnMessageShowing,
    firstPopUpShowing,
    isNewTurn,
    setNewTurn,
    playerStatus,
    isPlanning,
    SoundPlay,
    playerStatusChange,
    soundForFlipAndCards,
    toggleStartGamePopUp,
    setUpdatedCards,
    different,
    isCardOpen,
    toggleIsAnimationNeeded,
    animationVars,
    log,
    disableExecuteBtnFunc,
    disableExecuteBtn,
    value,
    playerName,
    handleProgress,
    BeginTurnPopUpShow,
    updateOrTaskFlip,
    updateFirstArrangement,
    changesMade,
    setChangesMade,
    bumpReorderAction,
    markManualReorderTouched,
    markTaskDragged,
    currentTileType,
    projectScopePopUps,
    ProjectScopeBackButtonDisabled,
    toggleDisableScreen,
    cardsLiveViewRefGlobal,
    setPressedOkGotIt,
    changedProjectOrder,
    firstProjectPopup,
    lastFlipped,
    setMovedTaskBeforePredecessorCount,
    oneLessStep,
    checkedTask,
    setCheckedTask,
    taskToggle,
    ExecuteTaskPopUpShow,
}) => {
    const { t } = useTranslation();

    const [cards, setCards] = useState(tasks);
    const [originalCards, setOriginalCards] = useState(JSON.parse(JSON.stringify(tasks)));
    const [orTasksBeforeSaveChanges, setOrTasksBeforeSaveChanges] = useState(tasks);
    const [stage, setStage] = useState(openStage);
    if (openGeneralPmTasks !== stage) setOpenGeneralPmTasks(stage);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(
        t('modals.cannot_move_task.info_text'),
    );
    const [cardsLiveView, _setCardsLiveView] = useState(tasks)
    const [modalTitle, setModalTitle] = useState(t('modals.cannot_move_task.info_title'));
    const [checkedTaskRedo, setCheckedTaskRedo] = useState(false);
    const [checkedTaskDBId, setCheckedTaskDBId] = useState(null);
    const [hoverCard, setHoverCard] = useState(null);
    const [isOrTask, setIsOrTask] = useState(false);
    // const [changesMade, setChangesMade] = useState(false);
    const [generalTaskChecked, setGeneralTaskChecked] = useState([]);
    const [displayBigMap, setDisplayBigMap] = useState(false);
    const [backupCardsLiveView, setBackupCardsLiveView] = useState({});
    const [hoverCardId, setHoverCardId] = useState();
    const [arrayOfLastHoverIndexes, setArrayOfLastHoverIndexes] = useState([]);
    const [arrayOfLastDragIndexes, setArrayOfLastDragIndexes] = useState([]);
    const [orFlipped, setOrFlipped] = useState('transform 0s');
    const [renderingIndependently, setRenderingIndependently] = useState(false);
    const [draggedId, setDraggedId] = useState(0);
    const currentlyDragged = useRef();
    const cardsLiveViewCords = useRef([]);
    const [items, setItems] = useState(4);

    const setCardsLiveView = (_value) => {
        _setCardsLiveView(_value)
        cardsLiveViewRefGlobal.current = _value;
    }
    useEffect(() => {
        cardsLiveViewRefGlobal = tasks
    }, [])
    // Reset checkedTaskDBId when game changes to avoid stale task IDs from previous project
    useEffect(() => {
        setCheckedTaskDBId(null);
    }, [gameId])
    const buttonTextFunc = () => {
        if (generalTaskChecked.length != 0) {
            return t(`project_sheet.execute`)
        }
        if (isNewTurn || ((currentTileType == 'mile-stone'))) {
            return t(`project_sheet.continue_playing`)
        }
        return t(`project_sheet.start_playing`)
    };

    const moveCardsLive = (dragCardIndex, dropCardIndex, currentDragIndex) => {
        setOrFlipped('transform 0s');
        const dragCard = cardsLiveView[dragCardIndex];
        const dropCard = cardsLiveView[dropCardIndex];
        if (dropCardIndex !== undefined && !dropCard.completed) {
            const tempUnsortedCardsList = [...cardsLiveView];
            const tempDragIndexArray = [...arrayOfLastDragIndexes];
            tempDragIndexArray.push(dragCardIndex);
            setArrayOfLastDragIndexes(tempDragIndexArray);

            const tempHoverIndexArray = [...arrayOfLastHoverIndexes];
            tempHoverIndexArray.push(dropCardIndex);
            setArrayOfLastHoverIndexes(tempHoverIndexArray);
            if (dragCardIndex < dropCardIndex) {
                tempUnsortedCardsList.map(item => {
                    if (item.id > (dragCardIndex + 1) && item.id <= (dropCardIndex + 1)) {
                        item.id -= 1;
                    }
                });

            } else {
                tempUnsortedCardsList.map(item => {
                    if (item.id < (dragCardIndex + 1) && item.id >= (dropCardIndex + 1)) {
                        item.id += 1;
                    }
                });
            }

            tempUnsortedCardsList[dragCardIndex].id = dropCardIndex + 1;

            // exchage card id's
            // [dropCard.id, dragCard.id] = [dragCard.id, dropCard.id];

            // Sort cards by new id
            // setCardsLiveView(tempUnsortedCardsList.sort((a, b) => (a.id < b.id ? -1 : 1)));
            setCardsLiveView(tempUnsortedCardsList);
        }
    }

    const moveTaskToDebounce = useCallback(
        (dragIndex, hoverIndex, hoverCardT, dragCardT) => {
            setOrFlipped('transform 0s');
            // console.log("dragIndex:", dragIndex);
            // console.log("hoverIndex:", hoverIndex);
            // console.log("hoverId:", hoverCardId);
            if (cardsLiveView[dragIndex].completed || cardsLiveView[hoverIndex].completed) {
                moveCardsLive(arrayOfLastHoverIndexes[arrayOfLastHoverIndexes.length - 1], arrayOfLastDragIndexes[0], dragIndex);
                setArrayOfLastDragIndexes([]);
                setArrayOfLastHoverIndexes([]);
                return;
            };
            if (dragIndex > hoverIndex) {
                // check the min value we can move task to:
                const arrayTasksBeforeCurrentCard = cardsLiveView.filter(({ id }) => id <= dragIndex + 1).reverse();
                const predecessorsArrayOfCurrentCard = cardsLiveView[hoverIndex].relationships;
                console.log("predecessorsArrayOfCurrentCard ", predecessorsArrayOfCurrentCard);
                console.log("arrayTasksBeforeCurrentCard ", arrayTasksBeforeCurrentCard);
                // console.log("Tasks before:", arrayTasksBeforeCurrentCard);
                // console.log("Predecessors:", predecessorsArrayOfCurrentCard);
                // console.log("cards:", cardsLiveView);
                let minValueWeCanDragTo = 0;
                for (let i = 0; i < arrayTasksBeforeCurrentCard.length; i++) {
                    if (predecessorsArrayOfCurrentCard.includes(arrayTasksBeforeCurrentCard[i].number)) {
                        minValueWeCanDragTo = arrayTasksBeforeCurrentCard[i].id;
                        break;
                    }
                }
                // console.log("Min value we can drag to:", minValueWeCanDragTo);
                // console.log("max drop index reletionships:", Math.max(...cardsLiveView[hoverIndex].relationships));
                let hoverOnThePreviousCard = true;
                const hoverCardIdOfNextCardFromRight = cardsLiveView[hoverIndex + 1].number;
                // console.log("hoverCardTOfNextCardFromRight:-)", hoverCardIdOfNextCardFromRight);
                // when pushing, we also need the next card T, because we still hover on the previous card:
                if (Math.max(...cardsLiveView[hoverIndex].relationships) == hoverCardIdOfNextCardFromRight) {
                    hoverOnThePreviousCard = false;
                }
                // console.log(
                //     "condition:1 ?", minValueWeCanDragTo > hoverIndex,
                //     "condition:2 ?", hoverCardId == Math.max(...cardsLiveView[hoverIndex].relationships),
                //     cardsLiveView[hoverIndex]
                // )
                if ((minValueWeCanDragTo > hoverIndex) || (hoverCardId == Math.max(...cardsLiveView[hoverIndex].relationships)
                    && hoverCardIdOfNextCardFromRight == Math.max(...cardsLiveView[hoverIndex].relationships))) {
                    moveCardsLive(arrayOfLastHoverIndexes[arrayOfLastHoverIndexes.length - 1], arrayOfLastDragIndexes[0], dragIndex);
                    setModalContent(t('modals.cannot_move_task.info_text'));
                    setArrayOfLastDragIndexes([]);
                    setArrayOfLastHoverIndexes([]);
                    setModalVisible(true);
                } else {
                    setChangesMade(true);
                }
            } else {
                // check the max value we can move task to:
                const arrayTasksAfterCurrentCard = cardsLiveView.filter(({ id }) => id > dragIndex);
                let maxValueWeCanDragTo = arrayTasksAfterCurrentCard.length;
                for (let i = 0; i < arrayTasksAfterCurrentCard.length; i++) {
                    if (arrayTasksAfterCurrentCard[i].relationships.includes(dragCardT)) {
                        maxValueWeCanDragTo = arrayTasksAfterCurrentCard[i].id;
                        break;
                    }
                }
                const maxIndexWeCanMoveTo = cardsLiveView.filter(({ id }) => id == maxValueWeCanDragTo);
                // console.log("max-value:", maxValueWeCanDragTo);
                // console.log("dragCardT:", dragCardT);
                // console.log("maxIndexWeCanMoveTo", maxIndexWeCanMoveTo[0].id);
                if (maxValueWeCanDragTo <= hoverIndex && maxIndexWeCanMoveTo[0].id <= hoverIndex + 1) {
                    moveCardsLive(arrayOfLastHoverIndexes[arrayOfLastDragIndexes.length - 1], arrayOfLastDragIndexes[0], dragIndex);
                    setArrayOfLastDragIndexes([]);
                    setArrayOfLastHoverIndexes([]);
                    setModalContent(t('modals.cannot_move_task.info_text'));
                    setModalVisible(true);
                } else {
                    setChangesMade(true);
                }
            }
        },
        [cardsLiveView, moveCardsLive],
    );

    const moveTask = debounce(moveTaskToDebounce, 10);
    const handleStageGeneralPMTasks = () => {
        if (openStage === 1 && playerPosition === 'mile-stone') {
            ProjectScopeDisable(true);
            console.log(580);
            // setModalContent('In milestone you can only preform general tasks'); for now, they don't want the pop up to appear, only disable it.
            // setModalVisible(true);
        } else {
            setStage(0);
        }
    };

    // const updateCardsList = (hoverIndex, dragIndex) => moveCard(hoverIndex, dragIndex);

    const handleTaskCheck = (cardNumber, orTask, isGeneralTask = false) => {

        if (isGeneralTask && cardNumber !== null) {
            if (generalTaskChecked.includes(cardNumber)) {
                setCheckedTask(null);
                // remove general task from array
                setGeneralTaskChecked(generalTaskChecked.filter(taskId => taskId !== cardNumber));
            } else {
                setCheckedTask(null);
                setGeneralTaskChecked([...generalTaskChecked, cardNumber]);
            }
        } else if (cardNumber === checkedTask) {
            setCheckedTask(null);
            setIsOrTask(orTask);
        } else {
            setIsOrTask(orTask);
            setCheckedTask(cardNumber);
        }
    };

    const handleHover = hoverIndex => {
        setHoverCard(hoverIndex);
    };
    const isAccordingToPlan = async (checkedTaskId, type, turnNumber) => {
        if (type !== 'planned-task') {
            return;
        }

        axios
            .get(
                `${fetchConfig.prefix}/project/done_tasks?gameId=${gameId}&userId=${playerId}`,
            )
            .then(async response => {
                const completedTasks = response.data.map(current => +current.value);
                let checked = checkedTaskId;
                for (let i = 0; i < completedTasks.length; i++) {
                    checked--;
                }

                if (checked > 0) {
                    const comment = 'Task executed out of order'
                    const baseUrl = `${fetchConfig.prefix}/game/commentit`
                    await axios
                        .get(
                            `${baseUrl}?gameId=${gameId}&userId=${playerId}&comment=${encodeURI(comment)}&taskRowId=${response.insertId}`,
                        )
                        .catch(error => console.log(error));
                }

            })
            .catch(error => {
                console.log('error: ', error);
            });
    };
    const updateOrTasksToCardsLiveView = () => {
        const tempCardsArray = [...cardsLiveView];
        for (let i = 0; i < tasks.length; i++) {
            tempCardsArray.map(item => {
                if (item.taskname == tasks[i].taskname) {
                    item.isOrFlipped = tasks[i].isOrFlipped;
                }
            });
        }
        setCardsLiveView(tempCardsArray);
    }
    const needAnimation = situation => {
        if (animationVars.isAnimationNeeded) {
            // eslint-disable-next-line default-case
            switch (situation) {
                case 'budget':
                    return different.budget;
                case 'value':
                    return different.earnedValue;
                case 'regular':
                    return different.resources.regular;
                case 'executive':
                    return different.resources.executive;
                case 'expensive':
                    return different.resources.expensive;
            }
        } else {
            return 0;
        }
    };
    // const handleHoverDebounce = debounce(handleHover, 10);
    if (!taskShow) return null;

    const onDrop = (__sourceId, sourceIndex, targetIndex, __targetId) => {
        // cardsLiveView[sourceIndex]?.redo || cardsLiveView[targetIndex]?.redo
        if (targetIndex === cardsLiveView.length || cardsLiveView[sourceIndex] === undefined || cardsLiveView[targetIndex] === undefined || cardsLiveView[sourceIndex]?.completed || cardsLiveView[targetIndex]?.completed) {  // card was dragged out of bound
            return
        }

        let constraints = [];  // select the cards from the dragged index to the dropped index
        if (sourceIndex < targetIndex) {
            constraints = cardsLiveView.slice(sourceIndex, targetIndex + 1)
        } else {
            constraints = cardsLiveView.slice(targetIndex, sourceIndex + 1)
        }

        const ids = constraints.map(e => e.id).filter(e => cardsLiveView[sourceIndex].relationships.includes(e));  // check if other cards are contained in our relationship
        constraints = constraints.map(e => e.relationships).flat().filter((e) => e == cardsLiveView[sourceIndex].id);  // check if other cards' relationships contain our id
        console.log(ids, constraints, sourceIndex > targetIndex, sourceIndex, targetIndex, (constraints.length > 0 && sourceIndex > targetIndex) || ids.length > 0)
        if (constraints.length > 0 || (ids.length > 0 && sourceIndex > targetIndex)) {  // if at least 1 element was matched, return
            setMovedTaskBeforePredecessorCount(true);
            setModalContent(t('modals.cannot_move_task.info_text'));
            setModalVisible(true);
            return;
        }
        setChangesMade(true);
        bumpReorderAction?.();
        markManualReorderTouched?.();
        const draggedTaskNumber = cardsLiveView[sourceIndex]?.number;
        if (draggedTaskNumber != null) {
            markTaskDragged?.(draggedTaskNumber);
        }

        const result = swap(cardsLiveView, sourceIndex, targetIndex);  // swap the 2 cards
        changedProjectOrder.current = !(originalCards.filter((e, index) => e.id === result[index].id).length === originalCards.length);
        return setCardsLiveView([...result]);  // set the result
    }

    const updateItems = () => {
        if (window.innerWidth >= 1220 && window.innerWidth <= 1660) {
            setItems(3);
        } else if (window.innerWidth <= 1220) {
            setItems(2);
        } else if (window.innerWidth > 1660) {
            setItems(4);
        }
    };

    useEffect(() => {
        // Initial setup
        updateItems();

        // Add event listener to update items on window resize
        window.addEventListener('resize', updateItems);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateItems);
        };
    }, []); // Empty dependency array to run this effect only once during 

    return (
        <>
            {displayBigMap && (
                <ExpendedMap
                    toggleDisableScreen={toggleDisableScreen}
                    style={{
                        boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.18)',
                        borderRadius: '8px',
                    }}
                    show={displayBigMap}
                    setShow={setDisplayBigMap}
                    value={value}
                    player={playerCurrentPosition}
                    playerName={playerName}
                    handleProgress={handleProgress}
                    isPaused={isPaused}
                    showIsPaused={showIsPaused}
                    toggleProject={toggleProject}
                    openStage={openStage}
                    StartTurnMessageDisable={StartTurnMessageDisable}
                    isStartTurnMessageShowing={isStartTurnMessageShowing}
                    toggleBeginTurnPopUp={toggleBeginTurnPopUp}
                    BeginTurnPopUpShow={BeginTurnPopUpShow}
                    setNewTurn={setNewTurn}
                    SoundPlay={SoundPlay}
                    ProjectScopeDisable={ProjectScopeDisable}
                    checkedTask={checkedTask}
                    taskToggle={taskToggle}
                    ExecuteTaskPopUpShow={ExecuteTaskPopUpShow}
                />
            )
            }
            <Container>
                {modalVisible &&
                    <ModalContainer>
                        <Modal
                            type="smallPopUp"
                            modalTitle={modalTitle}
                            modalText={modalContent}
                            modalButton={t('modals.cannot_move_task.button1')}
                            toggleShow={() => setModalVisible(false)}
                            show={modalVisible}
                        />
                    </ModalContainer>
                }
                <PageGrid style={styleReset} container spacing={4}>
                    {/* <PageInfo container lg={12}> */}
                    <PageInfo container>
                        <MainContent>
                            <NavigationWrapper
                                onClick={() => {
                                    setOpenGeneralPmTasks(0)
                                    if (ProjectScopeBackButtonDisabled) {
                                        return;
                                    }
                                    markReturnedToBoardFromProject(true);
                                    if (animationVars.cameFromSideBar) {
                                        setTimeout(() => toggleIsAnimationNeeded(true, false), 1000);
                                    }
                                    toggleDisableScreen(false);
                                    setChangesMade(false);
                                    if ((playerCurrentPosition != 0 || log.length >= 1) && changesMade) {
                                        updateOrTasksToCardsLiveView();
                                        setUpdatedCards(cardsLiveView);
                                        // doNotSetUpdatedCards(cards);
                                        toggleStartPlaying(true);
                                    } else if ((playerCurrentPosition != 0 || log.length >= 1) && !changesMade) {
                                        toggleProject(0);
                                    }
                                }}

                            >
                                <div style={{ cursor: 'pointer', display: (playerCurrentPosition === 0 && log.length < 1) ? "none" : "block" }}>
                                    <BackArrow style={{ marginRight: '11px' }} />
                                    {t(`project_sheet.back`)}
                                </div>
                            </NavigationWrapper>
                            <InfoContentWrapper>
                                <div style={{ width: '59%' }}>
                                    <h2>{t(`global_variables.projects.${ProjectInfo.projectId}.project_name`, { projectId: ProjectInfo.projectId })}</h2>
                                    <p>{t(`global_variables.projects.${ProjectInfo.projectId}.project_objective`, { projectId: ProjectInfo.projectId })}</p>

                                    <SwitchContainer>
                                        <SwitchLeftOption
                                            disabled={isDisabledPMTasks}
                                            stage={stage}
                                            isDisabledPMTasks={isDisabledPMTasks}
                                            onClick={() => {
                                                if (playerPosition === 'mile-stone') return
                                                handleStageGeneralPMTasks();
                                                if (generalTaskChecked.length > 0) {
                                                    setCheckedTask(null);
                                                    setGeneralTaskChecked([]);
                                                }
                                            }}
                                        >
                                            {t(`project_sheet.project_scope.project_scope_title`)}
                                        </SwitchLeftOption>
                                        <SwitchRightOption
                                            log={log}
                                            playerCurrentPosition={playerCurrentPosition}
                                            stage={stage}
                                            onClick={() => {
                                                if (isDisabledPMTasks) {
                                                    return;
                                                }
                                                if (playerCurrentPosition != 0 || log.length >= 1) {
                                                    setStage(1);
                                                    setOpenGeneralPmTasks(true)
                                                }
                                                if (checkedTask !== null) {
                                                    setGeneralTaskChecked([]);
                                                }
                                            }}
                                        >
                                            {t(`project_sheet.general_tasks.general_tasks_title`)}
                                        </SwitchRightOption>
                                    </SwitchContainer>
                                </div>

                                {playerCurrentPosition === 0 || isNewTurn || currentTileType == 'mile-stone' ? (
                                    // || showIsPaused === 2 ||
                                    <StartButton
                                        disabled={firstPopUpShowing || disableExecuteBtn}
                                        onClick={() => {
                                            lastFlipped = cardsLiveView.filter((e) => e.isOrFlipped).length || 0
                                            setPressedOkGotIt(false)
                                            disableExecuteBtnFunc(true);
                                            // isPaused(false);
                                            ProjectScopeDisable(true);
                                            console.log(800);
                                            if (generalTaskChecked.length > 0) {
                                                performPlannedTask(
                                                    generalTaskChecked,
                                                    false,
                                                    'general',
                                                    cards,
                                                );
                                            } else {
                                                updateOrTasksToCardsLiveView();
                                                if (isNewTurn) {
                                                    setTimeout(async () => { await sendCardsToServer(cardsLiveView, stage, playerId, gameId, true, changesMade) }, 1000);
                                                }
                                                // sendCardsToServer in delay, because we had bug 194 in Jira that sometimes
                                                // code 0 (start turn), and code 1 (arranged project) happened in the same time 
                                                // and caused bug in location column in DB - it caused rare bug in steps. 
                                                setNewTurn(false);
                                                if (
                                                    (playerCurrentPosition === 0 && log.length < 1) // fresh start
                                                    ||
                                                    (playerCurrentPosition === 0 && log.length >= 1 && !isNewTurn) // restart after failing gate
                                                ) {
                                                    setUpdatedCards(cardsLiveView); // should rearrange cards both time
                                                    toggleStartPlaying(true);
                                                    socketIO.emit("started-playing");  // - do not remove
                                                    // toggleProject(0);
                                                }
                                                if (isNewTurn || currentTileType == 'mile-stone' && (playerCurrentPosition !== 0 || log.length >= 1)) {
                                                    setChangesMade(false);
                                                    ProjectScopeDisable(false);
                                                    initializePlayer(
                                                        checkedTask,
                                                        cards,
                                                        playerCurrentPosition,
                                                    );
                                                    if (!isStartTurnMessageShowing) {
                                                        // isPaused(false); // moved this function to app.js in sendCardsToServer function
                                                        setNewTurn(false);
                                                        toggleProject(0, cardsLiveView);
                                                        toggleBeginTurnPopUp(true);
                                                    } else {
                                                        // isPaused(false); // moved this function to app.js in sendCardsToServer function
                                                        setNewTurn(false);
                                                        toggleProject(0, cardsLiveView);
                                                        startTurn();
                                                    }
                                                }
                                                setOpenGeneralPmTasks(false);
                                            }
                                        }}
                                    >
                                        {buttonTextFunc()}
                                    </StartButton>
                                ) : (
                                    <StartButton
                                        disabled={(stage === 0 ? checkedTask === null : generalTaskChecked.length === 0) || isCardOpen || disableExecuteBtn}
                                        onClick={async () => {
                                            disableExecuteBtnFunc(true);
                                            ProjectScopeDisable(true);
                                            updateOrTasksToCardsLiveView();
                                            if (generalTaskChecked.length > 0) {
                                                performPlannedTask(
                                                    generalTaskChecked,
                                                    false,
                                                    'general',
                                                    cardsLiveView,
                                                    undefined,
                                                    undefined,
                                                    generalTaskChecked.length
                                                );
                                                // ProjectScopeDisable(false);
                                                // disableExecuteBtnFunc(true);
                                                // !taskShow ? disableExecuteBtnFunc(false) : '';
                                                // isPlanning(false)
                                            } else {
                                                await sendCardsToServer(cardsLiveView, stage, playerId, gameId, true, changesMade)
                                                // Derive taskIdnumberInDB from cards when checkedTaskDBId is null/mismatched
                                                const cardForTask = cardsLiveView.find(c => c.number === checkedTask);
                                                const taskIdToSend = checkedTaskDBId ?? cardForTask?.taskIdnumberInDB ?? cardForTask?.id;
                                                if (!taskIdToSend) {
                                                    console.error('Cannot execute: no valid task ID for checked task', checkedTask);
                                                    ProjectScopeDisable(false);
                                                    disableExecuteBtnFunc(false);
                                                    return;
                                                }
                                                performPlannedTask(checkedTask, isOrTask, 'planned', cardsLiveView, isAccordingToPlan, taskIdToSend, 0, checkedTaskRedo);
                                                // disableExecuteBtnFunc(true);
                                                // !taskShow ? disableExecuteBtnFunc(false) : '';
                                                // isPlanning(false)
                                            }
                                        }}
                                    >
                                        {t(`project_sheet.execute`)}
                                    </StartButton>
                                )}
                            </InfoContentWrapper>
                        </MainContent>
                        <ContentGameContainer>
                            <ContentGameWrapper>
                                <InformationWrapper>
                                    <InformationWrapperFirstLine>
                                        <BudgetContainer>
                                            <Budget>{t(`global_variables.budget`)}</Budget>
                                            <AmountOfBudget>${`${playerInfo.budget}`}</AmountOfBudget>
                                            {/* <AmountOfBudget>
                                        <CountUp
                                            end={playerInfo.budget}
                                            duration={1}
                                            prefix="$"
                                            start={playerInfo.budget - needAnimation('budget')}
                                        />
                                    </AmountOfBudget> */}
                                        </BudgetContainer>
                                        <ValueContainer>
                                            <Value>{t(`global_variables.value`)}</Value>
                                            {/* <ValueAmount>
                                        <CountUp
                                            end={playerInfo.earned}
                                            duration={1}
                                            start={playerInfo.earned - needAnimation('value')}
                                        />
                                        <DiamondSm />
                                    </ValueAmount> */}
                                            <ValueAmount>
                                                {`${playerInfo.earned}`}
                                                <DiamondSm />
                                            </ValueAmount>
                                        </ValueContainer>
                                    </InformationWrapperFirstLine>
                                    <InformationWrapperSecondLine>
                                        <ResourcesContainer>
                                            <Resources>{t(`global_variables.resources.resources`)}</Resources>
                                            <Resources>
                                                <WhiteSource />
                                                {`${sources.white}`}
                                                {/* <CountUp end={sources.white} duration={1} start={sources.white - needAnimation('regular')} /> */}
                                            </Resources>
                                            <Resources>
                                                {`${sources.red}`}
                                                {/* <CountUp end={sources.red} duration={1} start={sources.red - needAnimation('executive')} /> */}
                                                <RedSource />
                                            </Resources>
                                            <Resources>
                                                {`${sources.green}`}
                                                {/* <CountUp end={sources.green} duration={1} start={sources.green - needAnimation('expensive')} /> */}
                                                <GreenSource />
                                            </Resources>
                                        </ResourcesContainer>
                                    </InformationWrapperSecondLine>
                                </InformationWrapper>
                                <ImageWrapper onClick={() => setDisplayBigMap(true)}>
                                    <Image imageData={imageData} />
                                </ImageWrapper>
                            </ContentGameWrapper>
                        </ContentGameContainer>
                    </PageInfo>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <div style={{ zIndex: 0 }}>
                            <CustomGridContextProvider onChange={onDrop} style={{}}>
                                {stage === 0 &&
                                    <CustomGridDropZone id="left" boxesPerRow={items} rowHeight={280} style={{ display: 'flex', height: cardsLiveView?.length ? `${(Math.ceil(cardsLiveView.length / items)) * 280}px` : '1000px' }}>
                                        {cardsLiveView.map((item, index) => (
                                            <GridItem key={index} style={{ height: '280px', width: '338px' }}>
                                                <Card
                                                    onlyOuter={true}
                                                    allCards={tasks}
                                                    key={index}
                                                    {...item}
                                                    index={index}
                                                    id={item.number}
                                                    cardId={item.id}
                                                    taskIdnumberInDB={item.taskIdnumberInDB}
                                                    completed={item.completed}
                                                    cardsLiveView={cardsLiveView}
                                                    checkedTask={checkedTask}
                                                    disabled={playerCurrentPosition === 0 || showIsPaused}
                                                    changesMade={changesMade}
                                                    playerStatus={playerStatus}
                                                    isPaused={isPaused}
                                                    showIsPaused={showIsPaused}
                                                    isPlanning={isPlanning}
                                                    SoundPlay={SoundPlay}
                                                    soundForFlipAndCards={soundForFlipAndCards}
                                                    setHoverCardId={setHoverCardId}
                                                    orFlipped={orFlipped}
                                                    renderingIndependently={renderingIndependently}
                                                    top={cardsLiveViewCords.current[index]?.top}
                                                    left={cardsLiveViewCords.current[index]?.left}
                                                    fullItem={item}
                                                    redo={item.redo}
                                                />
                                            </GridItem>
                                        ))}
                                    </CustomGridDropZone>
                                }
                            </CustomGridContextProvider>
                        </div>
                        <div style={{ position: "absolute", width: "100%", top: 0, zIndex: 1 }}>
                            <GridContextProvider onChange={onDrop}>
                                {stage === 0 &&
                                    <CustomGridDropZone id="left" boxesPerRow={items} rowHeight={280} style={{ display: 'flex', height: cardsLiveView?.length ? `${(Math.ceil(cardsLiveView.length / items)) * 280}px` : '1000px' }}>
                                        {cardsLiveView.sort((firstElement, secondElement) => {
                                            if (firstElement.completed && secondElement.completed) {
                                                return 0
                                            }

                                            if (firstElement.completed) {
                                                return -1
                                            }

                                            if (secondElement.completed) {
                                                return 1
                                            }
                                        }).map((item, index) => (
                                            !item.completed ? (
                                                <GridItem key={item.id} style={{ height: '280px', width: '338px' }}>
                                                    <Card
                                                        onlyOuter={false}
                                                        oneLessStep={oneLessStep}
                                                        key={item.id}
                                                        {...item}
                                                        index={index}
                                                        id={item.number}
                                                        cardId={item.id}
                                                        taskIdnumberInDB={item.taskIdnumberInDB}
                                                        completed={item.completed}
                                                        allCards={tasks}
                                                        isHovered={hoverCard === index}
                                                        // isOrTask={orTasks.includes(item.number)}
                                                        orTaskChangeHandler={orTaskChangeHandler}
                                                        moveTask={moveTask}
                                                        cardsLiveView={cardsLiveView}
                                                        moveCardsLive={moveCardsLive}
                                                        checkedTaskHandler={handleTaskCheck}
                                                        checkedTask={checkedTask}
                                                        setCheckedTaskDBId={setCheckedTaskDBId}
                                                        disabled={playerCurrentPosition === 0 || showIsPaused}
                                                        setChangesMade={setChangesMade}
                                                        changesMade={changesMade}
                                                        playerStatus={playerStatus}
                                                        isPaused={isPaused}
                                                        showIsPaused={showIsPaused}
                                                        isPlanning={isPlanning}
                                                        SoundPlay={SoundPlay}
                                                        soundForFlipAndCards={soundForFlipAndCards}
                                                        updateOrTaskFlip={updateOrTaskFlip}
                                                        setHoverCardId={setHoverCardId}
                                                        setArrayOfLastDragIndexes={setArrayOfLastDragIndexes}
                                                        setArrayOfLastHoverIndexes={setArrayOfLastHoverIndexes}
                                                        orFlipped={orFlipped}
                                                        setOrFlipped={setOrFlipped}
                                                        setCheckedTask={setCheckedTask}
                                                        renderingIndependently={renderingIndependently}
                                                        top={cardsLiveViewCords.current[index]?.top}
                                                        left={cardsLiveViewCords.current[index]?.left}
                                                        setDraggedId={setDraggedId}
                                                        fullItem={item}
                                                        redo={item.redo}
                                                        setCheckedTaskRedo={setCheckedTaskRedo}
                                                    />
                                                </GridItem>
                                            ) : (
                                                <div key={index} style={{ height: '280px', width: '338px', position: 'absolute', top: `${Math.floor((index) / items) * 280}px`, left: `${(index % items) * 338}px` }}>
                                                    <Card
                                                        oneLessStep={oneLessStep}
                                                        key={item.id}
                                                        {...item}
                                                        index={index}
                                                        id={item.number}
                                                        cardId={item.id}
                                                        taskIdnumberInDB={item.taskIdnumberInDB}
                                                        completed={item.completed}
                                                        allCards={tasks}
                                                        isHovered={hoverCard === index}
                                                        // isOrTask={orTasks.includes(item.number)}
                                                        orTaskChangeHandler={orTaskChangeHandler}
                                                        moveTask={moveTask}
                                                        cardsLiveView={cardsLiveView}
                                                        moveCardsLive={moveCardsLive}
                                                        checkedTaskHandler={handleTaskCheck}
                                                        checkedTask={checkedTask}
                                                        setCheckedTaskDBId={setCheckedTaskDBId}
                                                        disabled={playerCurrentPosition === 0 || showIsPaused}
                                                        setChangesMade={setChangesMade}
                                                        changesMade={changesMade}
                                                        playerStatus={playerStatus}
                                                        isPaused={isPaused}
                                                        showIsPaused={showIsPaused}
                                                        isPlanning={isPlanning}
                                                        SoundPlay={SoundPlay}
                                                        soundForFlipAndCards={soundForFlipAndCards}
                                                        updateOrTaskFlip={updateOrTaskFlip}
                                                        setHoverCardId={setHoverCardId}
                                                        setArrayOfLastDragIndexes={setArrayOfLastDragIndexes}
                                                        setArrayOfLastHoverIndexes={setArrayOfLastHoverIndexes}
                                                        orFlipped={orFlipped}
                                                        setOrFlipped={setOrFlipped}
                                                        setCheckedTask={setCheckedTask}
                                                        renderingIndependently={renderingIndependently}
                                                        top={cardsLiveViewCords.current[index]?.top}
                                                        left={cardsLiveViewCords.current[index]?.left}
                                                        setDraggedId={setDraggedId}
                                                        fullItem={item}
                                                        setCheckedTaskRedo={setCheckedTaskRedo}
                                                    />
                                                </div>
                                            )
                                        ))}
                                    </CustomGridDropZone>
                                }
                            </GridContextProvider>
                        </div>
                    </div>
                    {stage == 1 &&
                        GeneralPMTasks.map((current, index) => {
                            return (
                                <TasksArray
                                    key={index}
                                    id={index + 1}
                                    generalTaskChecked={generalTaskChecked}
                                    performPlannedTask={performPlannedTask}
                                    checkedTaskHandler={handleTaskCheck}
                                    generalTask={generalTask}
                                    showIsPaused={showIsPaused}
                                    {...current}
                                    currentTileType={currentTileType}
                                />
                            );
                        })}
                </PageGrid>
            </Container >
        </>
    );
}
export default React.memo(Tasks)